const debug = require("debug")("mutant:NotFoundPage")

import React from "react"

const NotFoundPage = () => <div>Page not found!</div>

export { NotFoundPage }
